import { FunctionalComponent, h } from "preact";
import common from "./common.css";

interface Props {
  isMobileOnly: number | boolean;
  isDrawerOpen?: boolean;
}

const Spinner: FunctionalComponent<Props> = (props: Props) => {
  const { isMobileOnly, isDrawerOpen } = props;

  return (
    <div
      className={
        isDrawerOpen ? common.spinnerWrapperTwo : common.spinnerWrapper
      }
    >
      <img
        className={isMobileOnly ? common.mobileSpinner : common.spinner}
        src="/assets/icons/korra-logo.svg"
      />
    </div>
  );
};

export default Spinner;
